<template>
  <div class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage"
       :data-active-color="activeColor">



    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="text-right pr-2">
 
        <a class="logo-mini"
           href="/">
          <div class="servel row mt-5 pb-3"> 
              <div :class="{'text-rigth': true, 'col-sm-4': !$sidebar.isMinimized, 'ml-4 pl-3': $sidebar.isMinimized }">
                <img width="32px" class="img-fluid" :src="logo" alt="logo">  
              </div>
              <div :class="{ 'col-sm-8 text-left pl-0 pt-3': true, 'ml-3 pl-1': $sidebar.isMinimized }">  
                 SERVEL
              </div>
          </div>
          
        </a> 
      </div>
      <slot>
          
      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<style scoped> 

.servel{
    font-size:18px;
    /* line-height: 30px; */
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: rgba(255, 255, 255, 0.2);

}
</style>
<script>
  export default {
    name: 'sidebar',
    props: {
      title: {
        type: String,
        default: 'Servel'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundImage: {
        type: String,
        default: '/static/img/sidebar-5.jpg'
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: '/img/logo1.jpg'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      sidebarStyle () {
        return {
          backgroundImage: `url(${this.backgroundImage})`
        }
      }
    },
    methods: {
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
